import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

function MenuButton({
                        path,
                        currentPath,
                        onClick,
                        icon: Icon,
                        label,
                        buttonText,                    // right-side text (optional, no fallback)
                        iconfirst = true,
                        afterClickingChange = true,
                        borders = null,
                        bordersClassPrefix = 'border-gray-',
                        showLabel = true,
                        showSpeechBubble = true,
                        showRightText = true,
                    }) {
    const isActive = currentPath === path;

    const borderClass = borders
        ? borders.split('').map((c) => `${bordersClassPrefix}${c}`).join(' ')
        : '';

    const linkClass = `${!afterClickingChange ? 'menu-item' : isActive ? 'menu-item-actual' : 'menu-item'} ${borderClass}`;

    return (
        <Link
            to={path}
            className={linkClass}
            onClick={() => onClick(path)}
            title={showSpeechBubble ? label : undefined}
        >
            {/* left chunk: icon + (optional) label */}
            <span className="menu-icon-wrapper">
        {iconfirst
            ? (Icon && (
                <Icon
                    className={
                        showLabel
                            ? (label === '' ? 'menu-icon-without-text' : 'menu-icon')
                            : 'menu-icon-without-text-2'
                    }
                />
            ))
            : label}

                {showLabel
                    ? (iconfirst
                        ? label
                        : (Icon && <Icon className={label === '' ? 'menu-icon-without-text' : 'menu-icon'} />))
                    : ''}

                {showSpeechBubble && <span className="menu-tooltip">{label}</span>}
      </span>

            {/* right-side text now INSIDE the pill */}
            {showRightText && !!buttonText && (
                <span className="menu-right-text in-pill">{buttonText}</span>
            )}
        </Link>
    );
}

MenuButton.propTypes = {
    path: PropTypes.string.isRequired,
    currentPath: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.elementType,
    label: PropTypes.string.isRequired,
    buttonText: PropTypes.string,          // optional; no fallback
    iconfirst: PropTypes.bool,
    afterClickingChange: PropTypes.bool,
    borders: PropTypes.string,
    bordersClassPrefix: PropTypes.string,
    showLabel: PropTypes.bool,
    showSpeechBubble: PropTypes.bool,
    showRightText: PropTypes.bool,
};

MenuButton.defaultProps = {
    iconfirst: true,
    afterClickingChange: true,
    borders: null,
    bordersClassPrefix: 'border-gray-',
    showLabel: true,
    showSpeechBubble: true,
    showRightText: true,
    buttonText: undefined,
};

export default MenuButton;